import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// Stuff used by Content
import "LIBS/jquery.cookies.js";

/**
* class HSN.WarrantyUpsellModal
*
* Encapsulates the functionality of a modal dialog that contains product warranty upsell.
**/
HSN.WarrantyUpsellModal = (function (parent) {
    __extends(WarrantyUpsellModal, parent);

    function WarrantyUpsellModal(config) {
        /**
        * new HSN.WarrantyUpsellModal()
        **/
        var modal = WarrantyUpsellModal.__super__.constructor.call(this, 'warranty-upsell-modal');
        this.commerceService = HSN.Instance()._getCommerceService();
        this.name = 'HSN.WarrantyUpsellModal';
        
        this.Close.off();
        this.Close.removeClass('ir');
        eventHandlers(this);

        HSN.DataLayer.helpers.virtualPageview(null, 'Modal: HPP Upsell', 'HPPUpsellModal', 'HPP Upsell');

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function (e) {
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Close', 'CloseButton');
            if(isExpressBuy(modal)) {
                window.location = window.location.protocol + '//' + window.location.hostname + '/checkout/order-review';
            }
            else {
                closeModal(modal);
            }                
        });

        $(modal.Content).on('click', '.add-hpp-button', function () {
            var bagIdentity = $(this).data('bag-id');
            var bagItemId = $(this).data('bi-id');
            var warrantyItemId = $(this).data('warranty-id');
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Add', 'AddButton');

            HSN.SetWait();
            modal.commerceService.AddWarrantyToBagItem({bagIdentity: bagIdentity, bagItemId: bagItemId, warrantyItemId: warrantyItemId}, {
                callback: function (data) {
                    HSN.RemoveWait();
                    if (data.success) {
                        modal.Refresh(bagItemId, isExpressBuy(modal));
                    }
                    else {
                        HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was an error attempting to add the warranty, please try again.');
                    }
                }
            });
        });

        $(modal.Content).on('click', '.remove-hpp-button', function () {
            var bagIdentity = $(this).parent().data('bag-id');
            var bagItemId = $(this).parent().data('bi-id');
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Remove', 'RemoveButton');

            HSN.SetWait();
            modal.commerceService.RemoveWarrantyFromBagItem({ bagIdentity: bagIdentity, bagItemId: bagItemId}, {
                callback: function (data) {
                    HSN.RemoveWait();
                    if (data.success) {
                        modal.Refresh(bagItemId, isExpressBuy(modal));
                    }
                    else {
                        HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was an error attempting to remove the warranty, please try again.');
                    }
                }
            });
        });

        $(modal.Content).on('click', '.continue-shopping', function() {
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'ContinueShopping', 'ContinueShoppingButton');
            closeModal(modal);
        });

        $(modal.Content).on('click', '.proceed-to-checkout', function() {
            HSN.DataLayer.helpers.metricEvent(null, 'HPPModal', 'Checkout', 'CheckoutButton');
            var path = isExpressBuy(modal) ? '/checkout/order-review' : '/checkout/bag';
            window.location = window.location.protocol + '//' + window.location.hostname + path;
        });

        $(modal.Content).on('keydown', '.proceed-to-checkout', function (e) {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                $(modal.Close).focus();
            }
        });
    }

    function isExpressBuy(modal) {
        return $('.action-container.express', modal.Content).length >0 ? true : false;
    }

    function isBagPage() {
        return $('#bag-template').length > 0;
    }

    function closeModal(modal) {
        if (isBagPage()) {
            window.location.reload();
        }
        else {
            modal.Hide();
        }
    }

    /**
        * HSN.WarrantyUpsellModal#Show() -> void
        * - productId (string): The identifier for the product to load the information into the modal for.
        *
        **/
    WarrantyUpsellModal.prototype._show = function (bagItemId, isExpressBuy, onAnimateCallback) {
        HSN.SetWait();
        $.ajax('/checkout/warranty-options/' + bagItemId, {
            context: this,
            cache: false,
            dataType: 'html',
            data: {isExpressBuy: isExpressBuy },
            success: function (data) {
                HSN.RemoveWait();
                var scope = this;
                scope.Root.removeClass('loading');
                scope.DisplayContent(data, onAnimateCallback);
            },
            error: function () {
                alert('Unfortunately there was an error attempting to load the content, please try again.');
                $('#modal-mask').remove();
                HSN.RemoveWait();
            }
        });
    };

    WarrantyUpsellModal.prototype.DisplayContent = function (htmlData, onAnimateCallback) {
        var scope = this;

        this.Content.showHtml(htmlData,
            0,
            function () {
                scope.Center();
                scope.Content.animate({ opacity: 1 });
                if (typeof onAnimateCallback === 'function') {
                    onAnimateCallback();
                }
            },
            function () {
            }
        );
    };
    return WarrantyUpsellModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/Checkout/WarrantyUpsellModal.js